var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormV2',{ref:"baseForm",attrs:{"model-class":_vm.DeviceSessionConfig,"id":_vm.id,"before-save-hook":_vm.beforeSaveHook}})}
var staticRenderFns = []

export { render, staticRenderFns }